import { createUseStyles } from 'react-jss';
import { Theme as WrenchTheme } from '@wds/styles';
import { SurveyTheme } from '@sm/webassets/dist/components/SurveyTheme/types';

type StyleClasses = 'container' | 'text' | 'link' | 'logo' | 'imageLink';
type StyleProps = {
  surveyTheme: SurveyTheme;
  logoColor: string;
};

const useStyles = createUseStyles<StyleClasses, StyleProps, WrenchTheme>(wrenchTheme => {
  const fontFamily = wrenchTheme.type.fontFamily.base;
  // smallest font-size is 14px in wrenchTheme.type.fontSize.bodySm (cannot use)
  const fontSize = '12px';
  const lineHeight = '15px';
  return {
    container: {
      margin: '0 auto',
      padding: 0,
    },
    text: {
      display: 'inline-block',
      textAlign: 'center',
      padding: 0,
      width: '100%',
      margin: '0',
      color: ({ surveyTheme }) => surveyTheme.questionColor,
      fontFamily,
      fontSize,
      lineHeight,
    },
    link: {
      display: 'inline-block',
      textDecoration: 'underline',
      color: ({ surveyTheme }) => surveyTheme.questionColor,
      fontFamily,
      fontSize,
      lineHeight,
    },
    logo: ({ logoColor }) => ({
      width: '100%',
      color: logoColor,
      fill: logoColor,
    }),
    imageLink: {
      width: '157px',
      margin: '2px auto 5px',
      display: 'block',
    },
  };
});

export default useStyles;
